// extracted by mini-css-extract-plugin
export default {"font":"body_font__1wXFe","background":"body_background__r81nH"};